
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)"
               size="medium" color="#fff"
               type="square-jelly-box"><p style="color: white"> {{loadingMessage}}</p></ngx-spinner>
  <router-outlet></router-outlet>



